export default "__VITE_ASSET__B7OztCN2__"